module.exports = __webpack_public_path__ + "static/img/hbq1009.c9a37f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hbq1009.jpg
// module id = z5nz
// module chunks = 0